<nz-spin [nzSpinning]="loading$ | async">
  <div class="drawer-form-wrapper">
    <div class="behaviour-card-sec">
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">
          {{
            caseParams.case?.student?.firstName +
              ' ' +
              caseParams.case?.student?.lastName
          }}
        </h3>
      </div>
      <div class="card-content-wrapper">
        <div class="content">
          <h4 class="title">Date Of Birth</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-calendar.svg"
              class="icon s-16"
              aria-label="Calendar"></svg-icon>
            {{
              caseParams.case?.student?.dateOfBirth ?? null | date: 'MM/dd/yyyy'
            }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Supervisor</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-supervisor.svg"
              class="icon s-16"
              aria-label="Supervisor"></svg-icon>
            {{ caseParams.case?.supervisorName }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Gender</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-male.svg"
              class="icon s-16"
              aria-label="Male"></svg-icon>
            {{ caseParams.case?.student?.gender }}
          </p>
        </div>
      </div>
    </div>
    <div class="header-with-cta without-border">
      <div class="cta-wrapper">
        <button nz-button nzType="primary" (click)="isAddFolderOpen = true">
          Add Folder
        </button>
      </div>
    </div>
    <div class="attachments-list" *ngIf="currentStep as step">
      <ng-container *ngTemplateOutlet="stepHeader; context: { step: step }">
      </ng-container>

      <div class="header-with-cta without-border">
        <div class="cta-wrapper">
          <button
            nz-button
            nzType="default"
            (click)="openAddAttachmentComponentDrawer(step)">
            Add Attachment
          </button>
          <button
            *ngIf="step.planTypeId > 0"
            nz-button
            nzType="primary"
            (click)="openAttemptQuestionnaireDrawer(step)">
            Attempt Questionnaire
          </button>
        </div>
      </div>

      <div class="bulk-actions" *ngIf="stepAttachmentCount(step) > 0">
        <!-- this will be fixed in next ng-zorro-antd update // -->

        <div class="action-wrapper">
          <span
            nz-checkbox
            [id]="'selectAll-' + step.planTypeId"
            [(ngModel)]="selectAllByStep[step.planTypeId]"
            (ngModelChange)="onSelectAllChange(step.folders, step.planTypeId)">
            Select All
          </span>

          <button
            nz-button
            nzType="default"
            [disabled]="selectedCount(step.folders) === 0"
            (click)="downloadSelectedAttachments(step)"
            class="mr-8">
            Download Selected ({{ selectedCount(step.folders) }})
          </button>
        </div>
      </div>

      <div *ngIf="step.folders.length > 0; else customNoResult">
        <nz-collapse [nzBordered]="false" [nzExpandIconPosition]="'end'">
          <nz-collapse-panel
            *ngFor="
              let folder of step.folders;
              let i = index;
              trackBy: trackByFolderId
            "
            [nzHeader]="folderTemplate"
            [(nzActive)]="folder.active"
            (nzActiveChange)="onFolderExpand(step.folders, i, $event)"
            [nzExtra]="extraTpl">
            <ng-template #folderTemplate>
              <div nzFlex>
                <span
                  nz-checkbox
                  [nzDisabled]="folder.attachments.length === 0"
                  [(ngModel)]="folder.selected"
                  (ngModelChange)="
                    onSelectFolderChange(
                      step.folders,
                      folder.folderId,
                      step.planTypeId
                    )
                  ">
                  <span class="folder-name">
                    {{ folder.folderName }} ({{ folder.attachments.length }})
                  </span>
                </span>
              </div>
            </ng-template>
            <nz-empty
              *ngIf="folder.attachments.length === 0"
              nzNotFoundImage="simple"
              nzNotFoundContent="No Attachments in This Folder"></nz-empty>
            <div
              class="file-upload-preview"
              *ngFor="
                let attachment of folder.attachments;
                trackBy: trackByAttachmentId
              ">
              <div class="file-upload-preview-item">
                <div>
                  <!-- this will be fixed in next ng-zorro-antd update // -->

                  <!-- NOSONAR -->
                  <span
                    nz-checkbox
                    [(ngModel)]="attachment.selected"
                    (ngModelChange)="
                      onAttachmentSelectionChange(step.folders, step.planTypeId)
                    ">
                  </span>
                </div>
                <!--eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
                <div
                  type="button"
                  class="file"
                  (click)="viewAttachmentDetails(attachment, step.planTypeId)"
                  (keydown.enter)="
                    viewAttachmentDetails(attachment, step.planTypeId)
                  ">
                  <svg-icon
                    class="f-shrink"
                    [title]="'View Attachment'"
                    src="/assets/icon/icon-report-green.svg"
                    aria-label="Report Green"></svg-icon>
                  <div class="about-file">
                    <h4 class="file-name resize">{{ attachment.name }}</h4>
                    <p class="file-description text s-14">
                      {{ attachment.description }}
                    </p>
                    <p class="file-desc">{{ attachment.fileSize }}</p>
                  </div>
                </div>
              </div>
              <div class="actions">
                <button
                  class="f-shrink"
                  nz-button
                  nzType="text"
                  (click)="onDelete(attachment.id)">
                  <svg-icon
                    [title]="'Delete Attachment'"
                    src="/assets/icon/icon-trash.svg"
                    class="icon s-20"
                    aria-label="Trash"></svg-icon>
                </button>
                <button
                  class="f-shrink"
                  nz-button
                  nzType="text"
                  (click)="downloadFile(attachment)">
                  <svg-icon
                    [title]="'Download Attachment'"
                    src="/assets/icon/icon-download.svg"
                    aria-label="Download"></svg-icon>
                </button>
              </div>
            </div>
            <ng-template #extraTpl>
              <button
                type="button"
                nz-button
                nzType="default"
                aria-label="Settings"
                class="collapse-btn">
                <svg-icon
                  [src]="
                    folder?.active
                      ? '/assets/icon/icon-minus.svg'
                      : '/assets/icon/icon-plus.svg'
                  "
                  class="icon s-12"
                  aria-label="Icon"></svg-icon>
              </button>
            </ng-template>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
      <ng-template #customNoResult>
        <nz-empty></nz-empty>
      </ng-template>
    </div>

    <div
      class="display-flex justify-content-between drawer-footer"
      *ngIf="steps.length > 0">
      <div class="footer-left">
        <p
          class="error-text wizard-hard-stop-msg"
          *ngIf="!isLastStep && currentStep?.isHardStop && !canProceed">
          At least one attachment is required to continue.
        </p>
        <p
          class="error-text wizard-hard-stop-msg"
          *ngIf="isLastStep && !canFinish">
          At least one attachment is required for every Required and Hard Stop
          plan to finish.
        </p>
      </div>
      <div class="footer-right">
        <button
          nz-button
          type="button"
          nzType="default"
          [disabled]="isFirstStep"
          (click)="onPrevious()">
          Previous
        </button>
        <button
          *ngIf="!isLastStep"
          nz-button
          type="button"
          nzType="primary"
          [disabled]="!canProceed"
          (click)="onNext()">
          Next
        </button>
        <button
          *ngIf="isLastStep"
          nz-button
          type="button"
          nzType="primary"
          [disabled]="!canFinish"
          (click)="onFinish()">
          Finish
        </button>
      </div>
    </div>
  </div>
</nz-spin>

<ng-template #stepHeader let-step="step">
  <div class="header-with-cta without-border">
    <div class="quetion-badge">
      <span class="badge">{{ currentIndex + 1 }}/{{ steps.length }}</span>
      <h3 class="title s-18">{{ step.title }}</h3>
      <span
        class="wizard-step__badge wizard-step__badge--hard-stop"
        *ngIf="step.isHardStop">
        Hard Stop
      </span>
      <span
        class="wizard-step__badge wizard-step__badge--required"
        *ngIf="!step.isHardStop && step.isRequired">
        Required
      </span>
      <ng-container *ngIf="step.helpText">
        <span class="wizard-step__help-separator">|</span>
        <span
          class="wizard-step__help"
          nz-tooltip
          [nzTooltipTitle]="step.helpText"
          [nzTooltipTrigger]="
            isHelpTextTruncated(step.helpText) ? 'hover' : null
          ">
          {{ step.helpText | truncate }}
        </span>
      </ng-container>
    </div>
  </div>
</ng-template>
<app-confirm-dialog
  [isVisible]="showConfirmDialog"
  [title]="'Delete Attachment'"
  [message]="confrimDialogMsg"
  [iconSrc]="'/assets/icon/icon-trash-red.svg'"
  [iconColor]="'red'"
  [cancelText]="'Cancel'"
  [confirmText]="'Delete'"
  [loading]="isDeleting"
  (confirmed)="handleDelete()"
  (cancelled)="handleCancel()"
  (closed)="handleCancel()">
</app-confirm-dialog>

<app-confirm-dialog
  [isVisible]="isAddFolderOpen"
  title="Folder Name"
  message=""
  [iconSrc]="'/assets/icon/icon-folder-plus.svg'"
  [iconColor]="'green'"
  [cancelText]="'Cancel'"
  [messageTemplate]="folderTemplate"
  [primaryButtonClass]="'btn btn-primary'"
  [confirmText]="'Save'"
  [loading]="isSavingFolder"
  (confirmed)="onSaveFolder()"
  (cancelled)="onCancelFolder()"
  (closed)="onCancelFolder()">
</app-confirm-dialog>

<ng-template #folderTemplate>
  <div class="drawer-form-wrapper mt-2">
    <form nz-form class="form" nzLayout="horizontal" [formGroup]="folderForm">
      <nz-form-item>
        <nz-form-control
          [nzErrorTip]="nameErrorTpl"
          [nzValidateStatus]="
            folderForm.get('name')?.invalid && folderForm.get('name')?.touched
              ? 'error'
              : ''
          ">
          <input
            name="Folder Name"
            type="text"
            nz-input
            id="name"
            formControlName="name"
            placeholder="Enter folder name" />
          <ng-template #nameErrorTpl>
            <ng-container *ngIf="folderForm.get('name')?.errors as errors">
              <span *ngIf="folderForm.get('name')?.errors?.['required']">
                Name is required
              </span>
              <span *ngIf="folderForm.get('name')?.errors?.['pattern']">
                Name is invalid
              </span>
              <span *ngIf="folderForm.get('name')?.errors?.['maxlength']">
                Name is not more than 50 characters
              </span>
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </form>
  </div>
</ng-template>

<ng-template #addAttachmentDrawerTitleTpl>
  <app-drawer-header
    [title]="'Attachment'"
    [breadcrumbText]="getStudentFullName()"
    [subtitle]="''"
    (drawerClose)="closeAddAttachmentDrawer()">
  </app-drawer-header>
</ng-template>

<ng-template #questionnairesDrawerTitleTpl>
  <app-drawer-header
    [title]="'Attempt Questionnaire'"
    [breadcrumbText]="getStudentFullName()"
    [subtitle]="'Questionnaire'"
    [helpText]="getQuestionnaireSectionHelpText()"
    (drawerClose)="closeQuestionnairesDrawer()">
  </app-drawer-header>
</ng-template>

<div style="display: none" aria-hidden="true">
  <ng-container *ngTemplateOutlet="addAttachmentDrawerTitleTpl"></ng-container>
  <ng-container *ngTemplateOutlet="questionnairesDrawerTitleTpl"></ng-container>
</div>
